const getToolSets = async ({ commit, rootGetters, dispatch }, payload) => {
    commit("SET_TOOL_SETS_LOADING", true);
    try {
        const customer = rootGetters["customer/CUSTOMER"];
        const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];
        const data = { ...payload, customer_id: customer.customer_id };

        if (customer.customer_id === 0) {
            data.customer_id = selected_customer.customer_id;
        }

        const response = await window.axios.get(`/proxy/ai/tool-sets?customer_id=${data.customer_id}`, data);
        if (response && response.data.success) {
            commit('SET_TOOL_SETS', response.data.toolSets)
        } else {
            throw response.data;
        }
    } catch (error) {
        dispatch("notifications/setError", error.message, { root: true });
    } finally {
        commit("SET_TOOL_SETS_LOADING", false);
    }
};

export default getToolSets;